
export * from '../../frontend-js-dependencies-web/__liferay__/exports/react-flow-renderer.js';

import __default__ from '../../frontend-js-dependencies-web/__liferay__/exports/react-flow-renderer.js';
export default __default__;
